import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-[#3A2E1C] bg-[#0A0906] mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src="/quodust-logo.png" alt="Quodust" className="w-10 h-10 rounded-md object-cover ring-1 ring-[#FFAB00]/40" />
            <span className="font-display text-2xl tracking-tight">QUODUST STRATEGY</span>
          </div>
          <p className="text-sm text-stone-400 max-w-xs">
            You got rugged. Welcome home. We burn the dust, hardwire Quotrons on Robinhood Chain,
            and route tokenized-stock yield back to $QUODUST holders.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-stone-500 mb-3">Camp</div>
          <ul className="space-y-2 text-sm text-stone-300">
            <li><Link to="/how" className="hover:text-[#FFAB00]">The flywheel</Link></li>
            <li><Link to="/treasury" className="hover:text-[#FFAB00]">Treasury proof</Link></li>
            <li><Link to="/holder" className="hover:text-[#FFAB00]">Holder dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-stone-500 mb-3">Follow</div>
          <ul className="space-y-2 text-sm text-stone-300">
            <li><a href="https://x.com/quoduststrategy" target="_blank" rel="noreferrer" className="hover:text-[#FFAB00]">X · @quoduststrategy</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-stone-500 mb-3">Disclaimers</div>
          <p className="text-xs text-stone-500 leading-relaxed">
            Nothing here is financial advice. $QUODUST is a meme project. Yield distributions
            are discretionary. Donations are non-refundable. Not an offering of securities.
          </p>
        </div>
      </div>
      <div className="text-center py-4 text-xs text-stone-600 border-t border-[#1b1612]">
        © 2026 Quodust Strategy — built in the ashes
      </div>
    </footer>
  );
}
